function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.4 0h23v22.8h21.2V0h23v69h-23V46h-21v23h-23.2M206 23h-20.3V0h63.7v23H229v46h-23m53.5-69h24.1l14.8 24.3L313.2 0h24.1v69h-23V34.8l-16.1 24.8-16.1-24.8V69h-22.6m89.2-69h23v46.2h32.6V69h-55.6"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#e44d26",
  d: "M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f16529",
  d: "M256 480.5V131h148.3L376 447"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ebebeb",
  d: "M142 176.3h114v45.4h-64.2l4.2 46.5h60v45.3H154.4m2 22.8H202l3.2 36.3 50.8 13.6v47.4l-93.2-26"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M369.6 176.3H255.8v45.4h109.6m-4.1 46.5H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8"
});

var SvgHtml5 = function SvgHtml5(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 512,
    height: 512
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiI+Cgk8dGl0bGU+SFRNTDUgTG9nbzwvdGl0bGU+Cgk8cGF0aCBkPSJNMTA4LjQgMGgyM3YyMi44aDIxLjJWMGgyM3Y2OWgtMjNWNDZoLTIxdjIzaC0yMy4yTTIwNiAyM2gtMjAuM1YwaDYzLjd2MjNIMjI5djQ2aC0yM00yNTkuNSAwaDI0LjFsMTQuOCAyNC4zTDMxMy4yIDBoMjQuMXY2OWgtMjNWMzQuOGwtMTYuMSAyNC44bC0xNi4xLTI0Ljh2MzQuMmgtMjIuNk0zNDguNyAwaDIzdjQ2LjJoMzIuNlY2OWgtNTUuNiIvPgoJPHBhdGggZmlsbD0iI2U0NGQyNiIgZD0iTTEwNy42IDQ3MWwtMzMtMzcwLjRoMzYyLjhsLTMzIDM3MC4yTDI1NS43IDUxMiIvPgoJPHBhdGggZmlsbD0iI2YxNjUyOSIgZD0iTTI1NiA0ODAuNVYxMzFINDA0LjNMMzc2IDQ0NyIvPgoJPHBhdGggZmlsbD0iI2ViZWJlYiIgZD0iTTE0MiAxNzYuM2gxMTR2NDUuNGgtNjQuMmw0LjIgNDYuNWg2MHY0NS4zSDE1NC40TTE1Ni40IDMzNi4zSDIwMmwzLjIgMzYuMyA1MC44IDEzLjZ2NDcuNGwtOTMuMi0yNiIvPgoJPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTM2OS42IDE3Ni4zSDI1NS44djQ1LjRoMTA5LjZNMzYxLjMgMjY4LjJIMjU1Ljh2NDUuNGg1NmwtNS4zIDU5LTUwLjcgMTMuNnY0Ny4ybDkzLTI1LjgiLz4KPC9zdmc+";
export { SvgHtml5 as ReactComponent };